<script lang="ts">
export default {
  name: "SearchResultsHeader",
};
</script>

<script setup lang="ts">
type Props = {
  label: string;
  searchTerm: string;
  gallery?: boolean;
  noLink?: boolean;
  url?: string;
  to?: string;
  target?: string;
};

const props = withDefaults(defineProps<Props>(), {
  gallery: false,
  noLink: false,
  url: undefined,
  to: undefined,
  target: undefined,
});

const { t } = useI18n();

const component = computed(() => {
  if (props.noLink) {
    return "div";
  } else if (props.gallery || props.url) {
    return "a";
  } else {
    return "router-link";
  }
});

const toOrHref = computed(() => {
  if (props.noLink) {
    return {};
  } else if (props.gallery) {
    return { href: `/gallery?query=${props.searchTerm}`, target: props.target };
  } else if (props.url) {
    return {
      href: `${props.url}?search[query]=${props.searchTerm}`,
      target: props.target,
    };
  } else if (props.to) {
    return { to: props.to, target: props.target };
  } else {
    return {
      to: { name: "search-index", query: { query: props.searchTerm } },
      target: props.target,
    };
  }
});
</script>
<template>
  <li class="result-header">
    <component
      :is="component"
      class="result-header__link result-header__link--header"
      v-bind="toOrHref"
      role="option"
    >
      <div class="result-header__body">{{ label }}</div>
      <div v-if="!noLink" class="result-header__hint ms-auto">
        <span> {{ t("mainFobizzNavbar.navbarSearch.results.showAll") }}</span>
        <i class="bi bi-arrow-right ms-2"></i>
      </div>
    </component>
  </li>
</template>

<style lang="scss" scoped>
.result-header {
  display: flex;
  align-items: center;

  &__link {
    display: flex;
    align-items: center;
    flex: 1 1;
    gap: $spacer-3;
    text-decoration: none;
    transition: background-color 0.2s ease-in-out;
    border-left: 3px solid transparent;
    font-size: $font-size-sm;
    font-weight: 500;
    padding: $spacer-75 $spacer-3;
    background-color: $gray-100;
    color: $body-color;

    &:hover {
      background-color: $hover-color;
    }

    &[aria-selected="true"] {
      background-color: $color-gray-200;
      border-left: 3px solid $brand-courses;
    }
  }

  &__body {
    display: flex;
    align-items: center;
    gap: $spacer-3;
  }

  &__hint {
    font-size: $font-size-xxs;
    color: $secondary;
    font-weight: normal;
  }
}
</style>
